import { Wallet, Lock } from "lucide-react";
import { MY_SALARY_SECTION } from "@/constants/testIds";

const COMPONENT_LABELS = { fijo_recurrente: "Percepción fija", variable: "Bono / percepción variable" };

export function MySalarySection({ currentSalary, compensationHistory }) {
  const hasAnything = currentSalary != null;
  const latest = compensationHistory?.[0];
  const hasBreakdown = latest?.base_salary != null;

  return (
    <div data-testid={MY_SALARY_SECTION.section} className="mb-6">
      <p className="text-sm font-semibold text-charcoal mb-2 flex items-center gap-1.5">
        <Wallet className="w-4 h-4 text-terracotta" strokeWidth={1.5} /> Mi salario
      </p>

      {!hasAnything ? (
        <p data-testid={MY_SALARY_SECTION.hiddenMessage} className="bg-card border border-petroleum/10 rounded-2xl p-4 text-sm text-charcoal/60 flex items-start gap-2">
          <Lock className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          Esta información no está disponible por ahora.
        </p>
      ) : (
        <div className="bg-card border border-petroleum/10 rounded-2xl p-4">
          <p className="text-xs text-charcoal/50">Compensación total mensual</p>
          <p data-testid={MY_SALARY_SECTION.currentSalary} className="text-2xl font-heading font-bold text-charcoal">
            ${currentSalary.toLocaleString("es-MX")}
          </p>

          {hasBreakdown && (
            <div className="mt-3 space-y-1.5 border-t border-petroleum/10 pt-3">
              <div className="flex justify-between text-sm">
                <span className="text-charcoal/60">Sueldo base</span>
                <span data-testid={MY_SALARY_SECTION.baseSalary} className="font-medium text-charcoal">${latest.base_salary.toLocaleString("es-MX")}</span>
              </div>
              {(Array.isArray(latest.components) ? latest.components : []).map((comp, i) => (
                <div key={i} data-testid={MY_SALARY_SECTION.componentRow} className="flex justify-between text-sm">
                  <span className="text-charcoal/60">{comp.name} <span className="text-charcoal/40">({COMPONENT_LABELS[comp.tag] || comp.tag})</span></span>
                  <span className="font-medium text-charcoal">${(comp.amount ?? 0).toLocaleString("es-MX")}</span>
                </div>
              ))}
              {!(Array.isArray(latest.components) && latest.components.length > 0) && (
                <p className="text-xs text-charcoal/40">Sin bonos ni percepciones adicionales registradas.</p>
              )}
            </div>
          )}

          {compensationHistory?.length > 0 && (
            <div className="mt-4 space-y-2 border-t border-petroleum/10 pt-3">
              <p className="text-xs font-semibold text-charcoal/60 uppercase tracking-wide">Historial</p>
              {compensationHistory.map((c) => (
                <div key={c.id} data-testid={MY_SALARY_SECTION.historyRow} className="text-sm text-charcoal/80 flex justify-between gap-3">
                  <span>
                    {c.previous_salary != null ? `$${c.previous_salary.toLocaleString("es-MX")} → ` : ""}
                    <span className="font-semibold">${(c.monthly_salary ?? 0).toLocaleString("es-MX")}</span>
                    {c.reason && <span className="text-charcoal/50"> · {c.reason}</span>}
                  </span>
                  <span className="text-xs text-charcoal/40 whitespace-nowrap">{c.effective_date}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
